module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg-menu"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        通知与公告\n    ")]), _vm._v(" "), _vm._l((_vm.msgList), function(msg) {
    return _c('div', {
      staticClass: "msg-item"
    }, [_c('i', {
      staticClass: "iconfont",
      class: {
        'icon-warning1': msg.type === 'warning', 'icon-remind1': msg.type === 'remind1', 'icon-information': msg.type === 'information',
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(msg.msg))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(msg.time))])])
  }), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/user/msgList"
    }
  }, [_vm._v("查看更多")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10631b1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tempControl/msgMenu.vue
// module id = 893
// module chunks = 1